/* @ngInject */
const accountData = (

) => {
  const self = {}

  return self
}
export default accountData



// WEBPACK FOOTER //
// ./public/javascript/sygem/account/services/data.service.js